import { MenuItem } from '@ui-lib/components';

export const PROFILE_MENU_ITEMS: MenuItem[] = [
  {
    titleTranslateKey: 'sidebar-menu.settings',
    icon: 'settings',
    url: '/profile',
  },
  {
    titleTranslateKey: 'sidebar-menu.notifications',
    icon: 'bell',
    url: '/profile/notifications',
  },
  {
    titleTranslateKey: 'sidebar-menu.accounts',
    icon: 'users',
    url: '/profile/accounts',
  },
  {
    titleTranslateKey: 'sidebar-menu.observer',
    icon: 'eye-scan',
    url: '/profile/observer',
  },
  {
    titleTranslateKey: 'sidebar-menu.api',
    icon: 'programming',
    url: '/profile/open-api',
  },
  {
    titleTranslateKey: 'sidebar-menu.referral',
    icon: 'referral',
    url: '/profile/referral',
  },
];
